import * as React from 'react';
import Modal from '@mui/material/Modal';
import { useContext } from 'react';
import { Modalv2Context } from '../../Contexts/Modalv2Context';

const Modalv2 = () => {
	const { modalContent, updateModalContent } = useContext(Modalv2Context);

	return (
		<Modal
			open={!!modalContent}
			onClose={() => {
				updateModalContent(null);
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			className="modal"
		>
			{modalContent ? modalContent : <></>}
		</Modal>
	);
};

export default Modalv2;
